export enum HelpCenterType {
  Disabled = 'Disabled',
  Zendesk = 'Zendesk',
  DirectLink = 'DirectLink',
}
